import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
  `,
}
